import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import HotelTabSection from './HotelTabSection';

export default Node.create({
  name: 'hotelTabSection',

  group: 'block',
  content: 'block*',

  addAttributes() {
    return {
      tab: {
        default: 'rooms',
        parseHTML: (el) => el.getAttribute('data-tab') || 'rooms',
        renderHTML: (attrs) => ({ 'data-tab': attrs.tab }),
      },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(HotelTabSection);
  },

  parseHTML() {
    return [{ tag: 'div[data-hotel-tab-section]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-hotel-tab-section': '' }), 0];
  },
});
